import PropTypes from 'prop-types';
import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import Modal from '../../components/modal';
import MoveToCategory from '../../components/move-to-category';
import { closeModal } from '../../actions/close-modal';
import withTranslate from '../../hoc/with-translate';

export const ChangePostCategoryModal = ({ categories, changeCategory, closeModal, categoryId, t }) =>
  <Modal onClose={closeModal}>
    <MoveToCategory
      onClick={changeCategory}
      onCancel={closeModal}
      categories={categories}
      currentCategoryId={categoryId}
      message={t('change-post-category-modal.move-post-to-another-category')}
    />
  </Modal>;

ChangePostCategoryModal.propTypes = {
  categories: PropTypes.array.isRequired,
  changeCategory: PropTypes.func.isRequired,
  closeModal: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
  categoryId: PropTypes.string,
};

const mapStateToProps = state => ({ categories: state.categories });

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      changeCategory: categoryId => closeModal(categoryId),
      closeModal,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(withTranslate(ChangePostCategoryModal));



// WEBPACK FOOTER //
// ./app/containers/change-post-category-modal/change-post-category-modal.js